import { useMatchMediaQuery } from './media-query.hook'

export const useIsTouchScreen = () => useMatchMediaQuery('(pointer: coarse)')
